import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { purchased } from "@/lib/analytics";
import { useAuth } from "@/context/AuthContext";

const go = (data) => {
  if (!data?.url) throw new Error("Stripe didn't return a link. Please try again in a moment.");
  window.location.assign(data.url);
};
const here = (path) => window.location.origin + path;

export const startCheckout = async (product, returnPath, notes, interval) => {
  try { go((await api.post("/billing/checkout", { product, return_url: here(returnPath), notes: notes || undefined, interval: interval || undefined })).data); return true; }
  catch (e) { toast.error(e.response ? errMsg(e) : e.message, { id: "billing" }); return false; }
};

export const openPortal = async (returnPath) => {
  try { go((await api.post("/billing/portal", { return_url: here(`${returnPath}?billing=portal`) })).data); return true; }
  catch (e) { toast.error(e.response ? errMsg(e) : e.message, { id: "billing" }); return false; }
};

export const nextPlan = (tier) => (tier === "free" ? "pro" : tier === "pro" ? "elite" : null);

export const useBillingReturn = () => {
  const { refreshBilling } = useAuth();
  const [params, setParams] = useSearchParams();
  const done = useRef(false);
  useEffect(() => {
    const b = params.get("billing");
    if (b && !done.current) {
      done.current = true;
      if (b === "success") { purchased(); api.post("/billing/sync").then(refreshBilling).then(() => toast.success("Payment confirmed. Welcome aboard.")).catch((e) => toast.error(errMsg(e))); }
      else if (b === "portal") api.post("/billing/sync").catch(() => {}).then(refreshBilling).then(() => toast.success("Subscription details updated"));
      else toast.message("Checkout cancelled");
      const p = new URLSearchParams(params); p.delete("billing"); setParams(p, { replace: true });
    } else refreshBilling();
    const onVis = () => document.visibilityState === "visible" && refreshBilling();
    document.addEventListener("visibilitychange", onVis);
    return () => document.removeEventListener("visibilitychange", onVis);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};
